// https://vuex.vuejs.org/en/getters.html

// The `getField()` and `updateField()`
// helper functions, are needed to update
// the mapped fields in a Vuex conform manner.
import { getField } from 'vuex-map-fields';

export default {
  getField,
  layout(state){
    return state.layout
  },
  current_user(state){
    return state.current_user
  }
}
